import React from 'react'
import { Container } from 'reactstrap'
import styled from 'styled-components'
import theme from '../../theme'
import { IconLink } from '../../common/Links'
import { Section, H4 } from '../../GlobalStyles'

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const FAQSection = () => {
  return (
    <Section bgColor={theme.colors.darkGray}>
      <Container>
        <H4>Frequently Asked Questions</H4>
        <ButtonsContainer>
          <IconLink
            target='_blank'
            url='https://www.pga.com/docs/pga-coach-profile-faq.pdf'
            aria-label='Read Our FAQs'
            padding='16px 0'
            color={theme.colors.white}
            hoverColor={theme.colors.white}
          >
            READ OUR FAQS
          </IconLink>
        </ButtonsContainer>
      </Container>
    </Section>
  )
}

export default FAQSection
